<template>
<q-dialog ref="dialog" @hide="onDialogHide">
  <q-card class="q-dialog-plugin"  style="width: 700px; max-width: 80vw;">
    <q-card-section>
      <div class="text-h6 q-mb-lg">Metody průzkumu</div>
      <q-input label="Metoda průzkumu" focused v-model="title"></q-input>
      <div class="row">
        <q-input class="q-pr-md col" label="Poznámka" focused v-model="tooltip" type="string"></q-input>
      </div>
      <div class="row">
        <q-input class="q-pr-md col" label="URL" focused v-model="url" type="string"></q-input>
      </div>
      <div class="row">
        <q-checkbox class="q-pr-md col" label="Lze vybrat" focused v-model="selectable"></q-checkbox>
      </div>
    </q-card-section>
    <!-- buttons example -->
    <q-card-actions align="right">
      <q-btn flat color="primary" label="Uložit" @click="onOKClick"/>
      <q-btn flat label="Storno" @click="onCancelClick"/>
    </q-card-actions>
  </q-card>
</q-dialog>
</template>
<script>
import { Vue, Component } from 'vue-property-decorator'

export default @Component({
  props: {
    taxonomyNode: Object
  }
})
class RequestorEditDialogComponent extends Vue {
  title = ''
  tooltip = ''
  url = ''
  selectable = true

  show () {
    if (this.taxonomyNode) {
      this.title = this.$langTitle(this.taxonomyNode)
      this.tooltip = this.taxonomyNode.tooltip || ''
      this.url = this.taxonomyNode.url || ''
      this.selectable = this.taxonomyNode.selectable || this.taxonomyNode.selectable === undefined
    }
    this.$refs.dialog.show()
  }

  hide () {
    this.$refs.dialog.hide()
  }

  onDialogHide () {
    this.$emit('hide')
  }

  onOKClick () {
    const node = (this.taxonomyNode || {})
    this.$emit('ok', {
      ...node,
      title: this.$setLangTitle(node.title, this.title),
      slug: this.node ? this.node.slug : this.title,
      url: this.url,
      tooltip: this.tooltip,
      selectable: this.selectable
    })
    this.hide()
  }

  onCancelClick () {
    this.hide()
  }
}
</script>
<style>

</style>
